import React from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
// core components
import footerStyle from "assets/jss/material-dashboard-react/components/footerStyle";

function Footer({ ...props }) {
  const { classes } = props;
  return (
    <footer className={classes.footer}>
      <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a
                href="https://www.3si.vn"
                className={classes.block}
                rel="noopener noreferrer"
                target="_blank"
              >
                Homepage
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="https://tech.3si.vn"
                className={classes.block}
                rel="noopener noreferrer"
                target="_blank"
              >
                3S Tech Blog
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="https://www.3si.vn/en/news/"
                className={classes.block}
                rel="noopener noreferrer"
                target="_blank"
              >
                3S News
              </a>
            </ListItem>
          </List>
        </div>
        <p className={classes.right}>
          <span>
            <a href="mailto:sale.ml@3si.vn" className={classes.a}>
              Sales Center
            </a>
            , from 3S Intersoft JSC with Love ❤
          </span>
        </p>
      </div>
    </footer>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(footerStyle)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.jsx